import React from "react";


const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">

        <div className="footer-grid">

          {/* LEFT */}
          <div className="footer-left">
            <div className="logo">IlyosDev</div>

            <p className="footer-text">
              Lorem ipsum dolor, sit amet consectetur adipisicing elit.
            </p>

            <div className="socials">
              <a href="https://www.facebook.com/share/1EAiMQCPP1/">FB</a>
              <a href="https://www.instagram.com/nuriddinov_ilyosbek_14">IG</a>
              <a href="@NuriddinovIlyosbek">TW</a>
              <a href="https://github.com/Ilyosbek0022">GH</a>
            </div>
          </div>

          {/* RIGHT */}
          <div className="footer-links">

            <div>
              <h3>About Us</h3>
              <ul>
                <li>Company History</li>
                <li>Team</li>
                <li>Careers</li>
              </ul>
            </div>

            <div>
              <h3>Services</h3>
              <ul>
                <li>Web Dev</li>
                <li>Design</li>
                <li>Marketing</li>
              </ul>
            </div>

            <div>
              <h3>Help</h3>
              <ul>
                <li>FAQ</li>
                <li>Support</li>
                <li>Live Chat</li>
              </ul>
            </div>

            <div>
              <h3>Contact</h3>
              <ul>
                <li>ilyosbeknuriddinov14@gmail.com</li>
                <li>+998 33 490 11 03</li>
                <li>Tashkent, Uzbekistan</li>
              </ul>
            </div>

          </div>
        </div>

        {/* bottom */}
        <div className="footer-bottom">
          <p>© 2026 IlyosDev</p>
          <div>
            <span>Terms</span>
            <span>Privacy</span>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;